import React, {useEffect, useState} from 'react';
import {isEmpty} from 'lodash';
import {buildGTMOrderEvent} from "../Analytics/googleOrderAdapter";
import {dataLayerPush} from "../Analytics/googleAnalyticsFour";

// https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#purchase
// 2026-03: google tag manager
//   https://developers.google.com/analytics/devguides/collection/ga4/ecommerce

const isDev = (process.env.NODE_ENV == 'development');

export function ReportOrderToGoogleTagManager({
  order, orderedItems, groupCollection, googleTagManager, debugReporting = false,
}) {
  const [reported, setReported] = useState(null);
  const debugGoogle = false;

  useEffect(() => {
    if (!order || isEmpty(orderedItems)) {
      console.error("ReportOrderToGoogleAnalytics4: required param missing");
      return;
    }

    // already reported?
    if (!isEmpty(reported)) { return; }

    let events = [
      {ecommerce: null},
      buildGTMOrderEvent({
        order, orderedItems, groupCollection
      })
    ]

    for (let event of events) {
      dataLayerPush(event);
    }

    // inhibit reporting it again
    setReported(events);
  }, [order?.id, reported]);

  if (isDev || debugGoogle) {
    return <pre className="debug" style={{color: 'teal', fontWeight: 'normal'}}>
    {JSON.stringify(reported, null, 2)}
  </pre>
  }

  return null;
}
